exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "#container {\n\tz-index: 1;\n\tposition: relative;\n\tmargin: 0 auto;\n\tmin-height: 10vh;\n\t-webkit-box-sizing: border-box;\n\t        box-sizing: border-box;\n}\n\n* {\n\tpadding: 0; \n\tmargin: 0;\n\tmin-height: 0;\n\tmin-width: 0;\n}\n", ""]);
